const replaceEmojis = (str) => {
  const cleanStr = str.replace(
    /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD00-\uDFFF]|[\uD83C-\uD83E])/gi,
    '',
  )
  // console.log({ str, cleanStr })
  return cleanStr
}

export default replaceEmojis
